export interface PublicConfig {
  services: {
    googleConfig: {
      apiKey: string
    }
    firebase: {
      apiKey: string
      authDomain: string
      projectId: string
      storageBucket: string
      messagingSenderId: string
      appId: string
      measurementId: string
    }
    mapbox: {
      accessToken: string
    }
    sentry: {
      dsn: string
    }
  }
}

export default function publicConfig() {
  return process.env.PUBLIC_CONFIG as unknown as PublicConfig
}

export const version = process.env.VERSION
export const versionNumber = process.env.VERSION_NUMBER
